
import WebFormList from './web_form_list'
import WebForm from './web_form'
import FileUploader from "./file_uploader";

frappe.ready(function() {
	let wrapper = $(".web-form-wrapper");
	let is_list = parseInt(wrapper.data('is-list'));
	let webform_doctype = wrapper.data('web-form-doctype');
	let webform_name = wrapper.data('web-form');
	let webform_controller = wrapper.data('web-form-controller') || 'frappe.website.doctype.web_form.web_form' ;
	let login_required = parseInt(wrapper.data('login-required'));
	let allow_delete = parseInt(wrapper.data('allow-delete'));
	let allow_select = parseInt(wrapper.data('allow-select')) || 1;
	let allow_workflow_actions = parseInt(wrapper.data('allow-workflow-actions')) || 0;
	let query_params = frappe.utils.get_query_params();
	let doc_name = query_params.name || '';
	let is_new = query_params.new;

	frappe.ui.FileUploader = FileUploader;

	if (login_required) show_login_prompt();
	else if (is_list) show_grid();
	else show_form(webform_doctype, webform_name, is_new);

	document.querySelector("body").style.display = "block";

	function show_login_prompt() {
		window.location.replace('/login?redirect-to=' + window.location.pathname);
	}

	function show_grid() {
		new WebFormList({
			parent: wrapper,
			doctype: webform_doctype,
			web_form_name: webform_name,
			webform_controller: webform_controller,
			allow_workflow_actions: allow_workflow_actions,
			allow_select : allow_select,
			settings: {
				allow_delete
			}
		})
	}

	function show_form(webform_doctype, webform_name, is_new) {
		let web_form = new WebForm({
			parent: wrapper,
			is_new,
			webform_controller: webform_controller,
			allow_workflow_actions: allow_workflow_actions,
			web_form_name: webform_name,
		});

		get_data().then(r => {
			if (!r.message) { frappe.throw(__('No response from server')) }
			const data = setup_fields(web_form, r.message);
			let web_form_doc = data.web_form;

			// if (web_form_doc.name && web_form_doc.allow_edit === 0) {
			// 	if (!window.location.href.includes("?new=1")) {
			// 		window.location.replace(window.location.pathname + "?new=1");
			// 	}
			// }
			let doc = r.message.doc || build_doc(r.message);
			web_form.prepare(web_form_doc, doc);
			web_form.make();
			web_form.set_default_values();
		})

		function build_doc(form_data) {
			let doc = { doctype: form_data.web_form.doc_type };
			form_data.web_form.web_form_fields.forEach(df => {
				if (df.default) return doc[df.fieldname] = df.default;
			});
			return doc;
		}


		function get_data() {
			return frappe.call({
				method: webform_controller + '.get_form_data',
				args: {
					doctype: webform_doctype,
					docname: doc_name,
					web_form_name: webform_name,
				},
				freeze: true,
				async: false,
			});
		}

		function setup_fields(web_form, form_data) {
			form_data.web_form.web_form_fields.map(df => {
				//df.get_status = web_form.get_field_status;

				if (df.fieldtype === 'Autocomplete' && df.options )
				{
					df.ignore_validation = df.read_only
					try {
						df.options = JSON.parse(df.options)
					} catch (e) {}
				}
				if (df.fieldtype === "Table") {
					df.get_data = () => {
						let data = [];
						if (form_data.doc) {
							data = form_data.doc[df.fieldname];
						} else if (df.data) {
							data = df.data;
						}
						return data;
					};

					df.fields = form_data[df.fieldname];
					$.each(df.fields || [], function(_i, field) {
						if (field.fieldtype === "Link") {
							field.only_select = true;
							//TODO: need to fix this..formatter has a bug...
							field.link_onclick = " ";
						}
						if (["Attach", "Attach Image"].includes(field.fieldtype)) {
							if (!field.options)
								field.options = {};
							else if (field.options == 'Private')
								field.options = { 'force_private_public': 'Private' };
							else if (field.options == 'Public')
								field.options = { 'force_private_public': 'Public' };

							field.options.disable_file_browser = true;
							field.options.doctype = webform_doctype;
							field.options.docname = doc_name;
							//field.options.fieldname = df.fieldname + ' ' + field.fieldname;
						}

						field.is_web_form = true;
						//field.get_status = web_form.get_field_status;
						field.parentfield = df.fieldname
						field.parenttype = df.fieldtype

					});


					df.is_web_form = true;

					delete df.parent;
					delete df.parentfield;
					delete df.parenttype;
					delete df.doctype;

					return df;
				}
				if (df.fieldtype === "Link") {
					df.only_select = true;
				}
				if (["Attach", "Attach Image"].includes(df.fieldtype)) {
					if (!df.options)
						df.options = {};
					else if (df.options == 'Private') {
						df.options = { 'force_private_public': 'Private' };
					}
					else if (df.options == 'Public') {
						df.options = { 'force_private_public': 'Public' };
					}
					df.options.disable_file_browser = true;

					df.options.doctype = webform_doctype;
					df.options.docname = doc_name;
					df.options.fieldname = df.fieldname;
				}
			});

			return form_data;
		}
	}
});
